import { AuthRoutingModule } from '@app/modules/auth/auth-routing.module';
import { CookieService } from 'ngx-cookie-service';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';

import { DomainInputModule } from '../ui/domain-input/domain-input.module';
import { PasswordBoxModule } from '../ui/password-box/password-box.module';

import { EmailChangeConfirmationComponent } from './containers/email-change-confirmation/email-change-confirmation.component';
import { FindCompanyComponent } from './containers/find-company/find-company.component';
import { FindCompanyEmailSentComponent } from './containers/find-company/email-sent/find-company-email-sent.component';
import { MobileAppsBadgesComponent } from './components/mobile-apps-badges/mobile-apps-badges.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LegalTermsFooterModule } from '../ui/legal-terms-footer/legal-terms-footer.module';

import { RegisterBlockedComponent } from './containers/register-new/blocked/register-blocked.component';
import { RegisterBlockedComponent as RegisterBlockedOldComponent } from './containers/register/blocked/register-blocked.component';
import { RegisterEmailSentComponent } from './containers/register-new/email-sent/register-email-sent.component';
import { RegisterEmailSentComponent as RegisterEmailSentOldComponent } from './containers/register/email-sent/register-email-sent.component';
import { RegisterComponent } from './containers/register-new/register.component';
import { RegisterComponent as RegisterOldComponent } from './containers/register/register.component';
import { IcLoadingIndicatorComponent } from '@shared/modules/icons/components/ic/ic-loading-indicator.component';

@NgModule({
  imports: [
    AuthRoutingModule,
    MatCheckboxModule,
    PasswordBoxModule,
    ReactiveFormsModule,
    SharedModule,
    PasswordBoxModule,
    DomainInputModule,
    LegalTermsFooterModule,
    IcLoadingIndicatorComponent
  ],
  declarations: [
    EmailChangeConfirmationComponent,
    FindCompanyComponent,
    FindCompanyEmailSentComponent,
    MobileAppsBadgesComponent,
    RegisterBlockedComponent,
    RegisterComponent,
    RegisterEmailSentComponent,
    RegisterBlockedOldComponent,
    RegisterEmailSentOldComponent,
    RegisterOldComponent
  ],
  providers: [CookieService],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AuthModule {}
